import { http } from '../../http';
import { useCustomConfig } from '@/js/composables/useCustomAxiosRequestConfig';
import { __ } from '@/js/stores/expressions';
import type { OneOffJobEntry, OneOffJobTriggerResponse } from './types';

export const triggerBackfillAnalysisReceivedAt = async (): Promise<OneOffJobTriggerResponse> => {
    return http
        .backoffice()
        .post<OneOffJobTriggerResponse>(
            'one-off-jobs/backfill-analysis-received-at',
            {},
            useCustomConfig({
                errorMessage: {
                    500: __('error-trigger-backfill-analysis-received-at'),
                    502: __('error-trigger-backfill-analysis-received-at'),
                },
            })
        )
        .then((response) => response.data);
};

export const getBackfillAnalysisReceivedAtJobs = async (): Promise<OneOffJobEntry[]> => {
    return http
        .backoffice()
        .get<OneOffJobEntry[]>(
            'one-off-jobs/backfill-analysis-received-at',
            useCustomConfig({
                errorMessage: {
                    500: __('error-load-backfill-analysis-received-at-jobs'),
                    502: __('error-load-backfill-analysis-received-at-jobs'),
                },
            })
        )
        .then((response) => response.data);
};
